export const uskaCardWording = [
    {
        name: 'RESTAURATION',
        title: 'Votre restaurant est-il au menu des recherches ?',
        text: 'Boostez votre visibilité en ligne avec un bilan gratuit'
    },
    {
        name: 'HOTELLERIE_PLEIN_AIR',
        title: 'Les campeurs vous repèrent-ils avant de planter leur tente ?',
        text: 'Boostez votre visibilité en ligne avec un bilan gratuit'
    },
    {
        name: 'ACTIVITE',
        title: 'Vos expériences sortent-elles du lot sur Google ?',
        text: 'Boostez votre visibilité en ligne avec un bilan gratuit'
    },
    {
        name: 'HOTELLERIE',
        title: 'Etes-vous le premier choix des voyageurs ? ',
        text: 'Boostez votre visibilité en ligne avec un bilan gratuit'
    },
    {
        name: 'COMMERCE_ET_SERVICE',
        title: 'Votre activité sort-elle du lot sur internet ?',
        text: 'Boostez votre visibilité en ligne avec un bilan gratuit'
    },
    {
        name: 'PATRIMOINE_CULTUREL',
        title: 'Votre fiche Google est-elle aussi captivante que vos expositions ?',
        text: 'Boostez votre visibilité en ligne avec un bilan gratuit'
    },
    {
        name: 'PATRIMOINE_NATUREL',
        title: 'Etes-vous dans le paysage des recherches locales ? ',
        text: 'Boostez votre visibilité en ligne avec un bilan gratuit'
    },
    {
        name: 'HEBERGEMENT_COLLECTIF',
        title: 'Vos clients vous trouvent-ils sur internet ?',
        text: 'Découvrez la performance de votre visibilité en ligne gratuitement'
    },
    {
        name: 'PRODUCTEUR',
        title: 'Vos clients vous trouvent-ils sur internet ?',
        text: 'Découvrez la performance de votre visibilité en ligne gratuitement'
    },
    {
        name: 'HEBERGEMENT_LOCATIF',
        title: 'Vos clients vous trouvent-ils sur internet ?',
        text: 'Découvrez la performance de votre visibilité en ligne gratuitement'
    },
    {
        name: 'EQUIPEMENT',
        title: 'Vos expériences sortent-elles du lot sur Google ?',
        text: 'Découvrez la performance de votre visibilité en ligne gratuitement'
    },
    {
        name: 'FETE_ET_MANIFESTATION',
        title: 'Vos clients vous trouvent-ils sur internet ?',
        text: 'Découvrez la performance de votre visibilité en ligne gratuitement'
    },
]